import { lightTheme as DefaultTheme } from '../Modes';

import createTheming from './createTheming';

export const { ThemeProvider, withTheme, useTheme, ThemeContext } = createTheming(DefaultTheme);

export { createTheming };
